import {
    CLOUDLOGINPAGE_SEARCH_TEMPLATES_REQUEST,
    CLOUDLOGINPAGE_SEARCH_TEMPLATES_RESULT,
    CLOUDLOGINPAGE_SAVE_TEMPLATE_REQUEST,
    CLOUDLOGINPAGE_SAVE_TEMPLATE_RESULT,
    CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST,
    CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_RESULT,
    CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST,
    CLOUDLOGINPAGE_GET_LOGIN_PAGE_RESULT,
    CLOUDLOGINPAGE_CONFIRM_TO_SAVE_OPEN_MODAL,
    CLOUDLOGINPAGE_CONFIRM_TO_SAVE,
    CLOUDLOGINPAGE_CONFIRM_TEMPLATE_OPEN_MODAL,
    CLOUDLOGINPAGE_CONFIRM_TEMPLATE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    imageList: [],
    result: null,
    saveContentResponse: null,
    saveContentError: null,
    loginPage: null,
    confirmToSave: false,
    confirmToSaveOpenModal: false,
    confirmTemplate: false,
    confirmTemplateOpenModal: false,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case CLOUDLOGINPAGE_SEARCH_TEMPLATES_REQUEST:
            return { ...state }

        case CLOUDLOGINPAGE_SEARCH_TEMPLATES_RESULT:
            return { ...state }

        case CLOUDLOGINPAGE_SAVE_TEMPLATE_REQUEST:
            return { ...state }

        case CLOUDLOGINPAGE_SAVE_TEMPLATE_RESULT:
            return { ...state }

        case CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST:
            return { ...state, loading: true }

        case CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST:
            return { ...state, loading: true }

        case CLOUDLOGINPAGE_GET_LOGIN_PAGE_RESULT:
            return { ...state, loading: false, loginPage: action.payload }

        case CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_RESULT:
            return { ...state, loading: false, saveContentResponse: action.payload.data, saveContentError: action.payload.error }

        case CLOUDLOGINPAGE_CONFIRM_TO_SAVE_OPEN_MODAL:
            return { ...state, confirmToSaveOpenModal: action.payload }

        case CLOUDLOGINPAGE_CONFIRM_TO_SAVE:
            return { ...state, confirmToSave: action.payload }

        case CLOUDLOGINPAGE_CONFIRM_TEMPLATE_OPEN_MODAL:
            return { ...state, confirmTemplateOpenModal: action.payload }

        case CLOUDLOGINPAGE_CONFIRM_TEMPLATE:
            return { ...state, confirmTemplate: action.payload }

        case CLEAR_REDUX:
            return ["", "CLOUDLOGINPAGE_UPLOAD_IMAGE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};